import { render, staticRenderFns } from "./CardPieChart.vue?vue&type=template&id=6601f618&scoped=true&"
import script from "./CardPieChart.vue?vue&type=script&lang=js&"
export * from "./CardPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CardPieChart.vue?vue&type=style&index=0&id=6601f618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6601f618",
  null
  
)

export default component.exports